import FormInvoice from './FormW2'

export default FormInvoice
